import React, { useState, useEffect } from 'react';
import { getVolumeMatched } from "../../../../service/backend-api-service"
//import { Button } from 'react-bootstrap';
const VolumeMatched = (props) => {
    const [volumeMatched, setVolumeMatched] = useState(0)

    const roundOff = (reating) => {
        return Math.floor(reating * 100) / 100;
    }

    useEffect(() => {
        const fetchData = async () => {
            let marketId = props.marketId;
            let volumeMatched = await getVolumeMatched(marketId)
            if (volumeMatched) {
                setVolumeMatched(volumeMatched);
            }
        }
        fetchData();
        const interval = setInterval(() => { fetchData() }, 10000);
        return () => clearInterval(interval);
    }, [props.marketId])

    return (
        <>
          Matched : ${roundOff(volumeMatched)}
          </>
    )
}

export default VolumeMatched;